// removed by extract-text-webpack-plugin
module.exports = {"container":"_2y0aLQxnw8Eas29LH5V_sS","table":"fkOhxgl5iPKVR_AA3Tujr"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Custom/Add/AddProducts/ArchiveValues/styles.css
// module id = 3233
// module chunks = 0